import React from 'react'

const Contact = () => {
  return (
    <div className=' w-screen h-screen flex items-center justify-center'>
      <p className=' font-bold'>Page Under Construction.</p>
    </div>
  )
}

export default Contact